import Grid from '@material-ui/core/Grid';
import { useState } from 'react';
import { formatPhone } from '../../../helpers/phoneUtils';
import { Button, Checkbox, FormControlLabel, Typography, Box } from '@material-ui/core';
import FormSection from '../../../components/atom/FormSection';
import { Link } from 'react-router-dom';

function FieldValues({ label, value }) {
    return (
        <Grid item xs={12}>
            <b>{label}</b>
            <br />
            {value ? value : ''}
        </Grid>
    );
}

export default function BookingItemGuestSettings({ values, setFieldValue, bookingCanModify }) {
    const [bookingNotification, setBookingNotification] = useState(
        values.booking?.notification ? [...values.booking?.notification] : ['email']
    );
    const handleNotificationEventValue = (field, value) => {
        let bookingNotifications = [...bookingNotification];
        if (!bookingNotifications.includes(field) && value) {
            bookingNotifications.push(field);
        }
        if (!value) {
            bookingNotifications = bookingNotifications.filter(e => e !== field);
        }
        setBookingNotification(bookingNotifications);
        setFieldValue('booking.notification', bookingNotifications);
    };

    return (
        <FormSection title="Guest information">
            <FieldValues label="First name" value={values.booking?.user.firstname} />
            <FieldValues label="Last name" value={values.booking?.user.lastname} />
            <FieldValues label="Email" value={values.booking?.user.email} />
            <FieldValues label="Phone" value={formatPhone(values.booking?.user.phone)} />
            <Grid item xs={12}>
                <p style={{ marginBottom: 0 }}>Notifications*</p>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={values.booking?.notification.includes('email') || false}
                            onChange={ev =>
                                handleNotificationEventValue('email', !!ev.target.checked)
                            }
                        />
                    }
                    disabled={!bookingCanModify}
                    label="email"
                />
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.booking?.notification.includes('sms') || false}
                                onChange={ev =>
                                    handleNotificationEventValue('sms', !!ev.target.checked)
                                }
                            />
                        }
                        disabled={!bookingCanModify}
                        label="sms"
                    />
                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            Indicates that the user has consented to receive SMS from{' '}
                            <b>Activiter</b>. Ensure that proper consent was obtained before
                            enabling this setting.
                        </Typography>
                    </Box>
                </Box>
                <p style={{ fontSize: '0.5em' }}>* Applied on all bookings in that cart</p>
            </Grid>
            <Grid item xs={12}>
                <Link to={`/guests/${values.booking?.user.id}`} style={{ textDecoration: 'none' }}>
                    <Button variant="contained" fullWidth>
                        Jump to guest profile
                    </Button>
                </Link>
            </Grid>
        </FormSection>
    );
}
